import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    studentName: '',
    schoolName: '',
    studentClass: '',
    place: '',
    mode: '',
    parentContact: '',
    email: '' // Added email field
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Replace with your EmailJS service details
      await emailjs.send(
        'service_gnods0t',
        'template_g81e5aj',
        formData,
        'Q8CPTd1VSMn4CQoNw'
      );

      setSubmitStatus('success');
      setFormData({
        studentName: '',
        schoolName: '',
        studentClass: '',
        place: '',
        mode: '',
        parentContact: '',
        email: '' // Reset email field
      });
    } catch (error) {
      setSubmitStatus('error');
      console.error('Error sending email:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="enquiry-form" className="section" style={{ background: '#f8f9fa' }}>
      <div className="container">
        <h2 className="section-title">Enquire Now</h2>
        <p className="section-subtitle" style={{ marginBottom: '50px', fontSize: '1.2rem', color: '#666' }}>
          Get in touch to start your Chemistry learning journey
        </p>

        <div className="form-container">
          <form onSubmit={handleSubmit} className="enquiry-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="studentName">Student Name *</label>
                <input
                  type="text"
                  id="studentName"
                  name="studentName"
                  value={formData.studentName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="schoolName">School Name *</label>
                <input
                  type="text"
                  id="schoolName"
                  name="schoolName"
                  value={formData.schoolName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="studentClass">Class *</label>
                <select
                  id="studentClass"
                  name="studentClass"
                  value={formData.studentClass}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Class</option>
                  <option value="9">Class 9</option>
                  <option value="10">Class 10</option>
                  <option value="11">Class 11</option>
                  <option value="12">Class 12</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="place">Place/Area *</label>
                <input
                  type="text"
                  id="place"
                  name="place"
                  value={formData.place}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="mode">Preferred Mode *</label>
                <select
                  id="mode"
                  name="mode"
                  value={formData.mode}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Mode</option>
                  <option value="Online">Online</option>
                  <option value="Offline">Offline</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="parentContact">Parent Contact Number (WhatsApp) *</label>
                <input
                  type="tel"
                  id="parentContact"
                  name="parentContact"
                  value={formData.parentContact}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Added Email Field */}
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@email.com"
                />
              </div>

              <div className="form-group">
                {/* Empty div to maintain grid layout */}
                <div style={{ height: '42px' }}></div>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting}
              style={{ width: '200px', marginTop: '20px' }}
            >
              {isSubmitting ? 'Sending...' : 'Submit Enquiry'}
            </button>

            {submitStatus === 'success' && (
              <div className="success-message">
                Thank you! Your enquiry has been submitted successfully. We'll get back to you shortly. For urgent queries, feel free to call us.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="error-message">
                Sorry, there was an error submitting your enquiry. Please try again or contact us directly.
              </div>
            )}
          </form>
        </div>
      </div>

      <style jsx>{`
        .form-container {
          max-width: 800px;
          margin: 0 auto;
        }
        
        .enquiry-form {
          background: white;
          padding: 40px;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }
        
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
        }
        
        .form-group {
          text-align: left;
        }
        
        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 500;
          color: #333;
        }
        
        .form-group input,
        .form-group select {
          width: 100%;
          padding: 12px 15px;
          border: 2px solid #e0e0e0;
          border-radius: 8px;
          font-size: 1rem;
          font-family: 'Poppins', sans-serif;
          transition: border-color 0.3s ease;
        }
        
        .form-group input:focus,
        .form-group select:focus {
          outline: none;
          border-color: #667eea;
        }
        
        .success-message {
          background: #d4edda;
          color: #155724;
          padding: 15px;
          border-radius: 8px;
          margin-top: 20px;
          border: 1px solid #c3e6cb;
        }
        
        .error-message {
          background: #f8d7da;
          color: #721c24;
          padding: 15px;
          border-radius: 8px;
          margin-top: 20px;
          border: 1px solid #f5c6cb;
        }
        
        @media (max-width: 768px) {
          .form-row {
            grid-template-columns: 1fr;
            gap: 15px;
          }
          
          .enquiry-form {
            padding: 30px 20px;
          }
        }
      `}</style>
    </section>
  );
};

export default EnquiryForm;